"use client";

import { useSearchParams } from "next/navigation";

export default function LoginPage() {
  const searchParams = useSearchParams();
  const discordError = searchParams.get("discordError");

  const errorMessages: Record<string, string> = {
    exchange_failed: "Discord token exchange failed. Try again.",
    invalid_code: "Invalid authorization code. Try again.",
    user_fetch_failed: "Could not fetch your Discord profile. Try again.",
    invalid_state: "Session expired. Try again.",
    account_disabled: "Your account is disabled."
  };

  return (
    <main className="min-h-screen flex flex-wrap items-center justify-center bg-cad-bg px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-semibold tracking-wide text-cad-text">PUBLIC SAFETY CAD</h1>
          <p className="text-sm text-gray-400 mt-1">Computer Aided Dispatch System</p>
        </div>

        <div className="bg-cad-panel border border-cad-border rounded-lg p-6 space-y-4">
          {discordError && (
            <div className="text-sm text-red-400 bg-red-950/40 border border-red-900 rounded px-3 py-2">
              {errorMessages[discordError] || "Something went wrong with Discord login."}
            </div>
          )}

          <a
            href="/api/auth/discord/login"
            className="flex flex-wrap items-center justify-center gap-3 w-full bg-[#5865F2] hover:bg-[#4752c4] text-white font-medium rounded py-2.5 text-sm transition-colors"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
            </svg>
            Sign in with Discord
          </a>
        </div>
      </div>
    </main>
  );
}   